import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { request as executeRequest } from "@faire/web-api--source";
import { useQuery } from "@tanstack/react-query";
import isArray from "lodash/isArray";
import { GREENHOUSE_API_BASE_URL } from "./greenhouseApi";
var EMPLOYMENT_URL = "/v1/boards/faire/departments";
var CONSULTANT_URL = "/v1/boards/faireconsultants/departments";
export var WorkType = /*#__PURE__*/ function(WorkType) {
    WorkType["EMPLOYMENT"] = "EMPLOYMENT";
    WorkType["CONSULTANT"] = "CONSULTANT";
    return WorkType;
}({});
var _obj;
var URL_WORK_TYPE_MAP = (_obj = {}, _define_property(_obj, "EMPLOYMENT", EMPLOYMENT_URL), _define_property(_obj, "CONSULTANT", CONSULTANT_URL), _obj);
export var build = function(workType) {
    return {
        url: URL_WORK_TYPE_MAP[workType],
        route: URL_WORK_TYPE_MAP[workType],
        baseUrl: GREENHOUSE_API_BASE_URL,
        method: "GET",
        withCredentials: false
    };
};
var getDepartments = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(workType) {
        var response;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        executeRequest(build(workType))
                    ];
                case 1:
                    response = _state.sent();
                    if (!isArray(response.departments)) {
                        throw new Error("INVALID_RESPONSE");
                    }
                    return [
                        2,
                        response.departments
                    ];
            }
        });
    });
    return function getDepartments(workType) {
        return _ref.apply(this, arguments);
    };
}();
export var useGreenhouseQuery = function(workType) {
    return useQuery({
        queryKey: [
            "".concat(workType, "-departments")
        ],
        queryFn: function() {
            return getDepartments(workType);
        }
    });
};
